export default __webpack_public_path__ + "static/media/cert-general-staff-hkgcsmeaa-sc.06ecd081.jpg";